// extracted by mini-css-extract-plugin
var _1 = "NoBlock_buttonWrapper__60c1e";
var _2 = "NoBlock_info__b3fc9";
var _3 = "NoBlock_root__ae275";
export { _1 as "buttonWrapper", _2 as "info", _3 as "root" }
